module.exports = __webpack_public_path__ + "mt.svg?4f20d5a79880bb85d3733a8cea2cc22c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mt.svg
// module id = 1515
// module chunks = 0